export enum DashboardExperience {
    Factoring = 1,
    SCF_Buyer = 2,
    SCF_Seller = 3,
    SCF_Account = 4
}

export enum DashboardExperienceDisplayEnum {
    'Factoring' = 1,
    'SCF Buyer' = 2,
    'SCF Supplier' = 3,
    'SCF Account' = 4
}
